var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "b-navbar",
    { attrs: { toggleable: "xl", type: "dark", sticky: "" } },
    [
      _c(
        "b-navbar-brand",
        { attrs: { href: "https://conahcyt.mx/", target: "_blank" } },
        [
          _c("img", {
            staticClass: "conahcyt",
            attrs: {
              src: require("../../../content/images/logo_blanco.svg"),
              alt: "Conahcyt",
            },
          }),
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "logo-rizoma" }, [
        _c("img", {
          attrs: {
            src: require("../../../content/images/logo-rizoma-blanco.svg"),
            alt: "Logo Rizoma",
          },
        }),
      ]),
      _vm._v(" "),
      _c("b-navbar-toggle", { attrs: { target: "nav-collapse" } }),
      _vm._v(" "),
      _c("b-collapse", { attrs: { id: "nav-collapse", "is-nav": "" } }, [
        _c(
          "div",
          { staticClass: "nav-collapse-2" },
          [
            _c(
              "b-navbar-nav",
              [
                _c("b-nav-item", { attrs: { href: "https://secihti.mx/" } }, [
                  _c("span", {
                    domProps: {
                      textContent: _vm._s(_vm.$t("global.menu.home")),
                    },
                  }),
                ]),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-navbar-nav",
              { staticClass: "navbar-right" },
              [
                _c(
                  "b-nav-item",
                  {
                    attrs: {
                      href: "https://secihti.mx/centro-de-contacto-de-atencion/",
                    },
                  },
                  [
                    _c("span", { staticClass: "icon-ayuda" }),
                    _vm._v(" "),
                    _c("span", {
                      domProps: {
                        textContent: _vm._s(_vm.$t("global.menu.contacto")),
                      },
                    }),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "b-nav-item-dropdown",
                  {
                    staticClass: "pointer",
                    class: {
                      "router-link-active": _vm.subIsActive("/account"),
                    },
                    attrs: {
                      right: "",
                      id: "account-menu",
                      "active-class": "active",
                    },
                  },
                  [
                    _c(
                      "span",
                      {
                        staticClass: "navbar-dropdown-menu",
                        attrs: { slot: "button-content" },
                        slot: "button-content",
                      },
                      [
                        _c("span", { staticClass: "icon-usuario" }),
                        _vm._v(" "),
                        _c("span", {
                          staticClass: "no-bold",
                          domProps: {
                            textContent: _vm._s(
                              _vm.$t("global.menu.account.main")
                            ),
                          },
                        }),
                      ]
                    ),
                    _vm._v(" "),
                    _vm.authenticated
                      ? _c(
                          "b-dropdown-item",
                          {
                            attrs: {
                              "data-cy": "logout",
                              id: "logout",
                              "active-class": "active",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.logout()
                              },
                            },
                          },
                          [
                            _c("font-awesome-icon", {
                              attrs: { icon: "sign-out-alt" },
                            }),
                            _vm._v(" "),
                            _c("span", {
                              domProps: {
                                textContent: _vm._s(
                                  _vm.$t("global.menu.account.logout")
                                ),
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    !_vm.authenticated
                      ? _c(
                          "b-dropdown-item",
                          {
                            attrs: {
                              "data-cy": "login",
                              id: "login",
                              "active-class": "active",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.openLogin()
                              },
                            },
                          },
                          [
                            _c("font-awesome-icon", {
                              attrs: { icon: "sign-in-alt" },
                            }),
                            _vm._v(" "),
                            _c("span", {
                              domProps: {
                                textContent: _vm._s(
                                  _vm.$t("global.menu.account.login")
                                ),
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }